module.exports = __webpack_public_path__ + "static/media/logo2.b04c815e.png";